// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TagFilter_filter__mcYRT {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.TagFilter_group__rPgzn {
  display: flex;
  align-items: center;
  gap: 6px;
}

.TagFilter_groupLabel__DGeFD {
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #acacac;
}

.TagFilter_chip__4abxd {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  font-size: 12px;
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 12px;
  color: #838383;
  cursor: pointer;
}
.TagFilter_chip__4abxd:hover {
  border-color: #acacac;
}

.TagFilter_chipOn__dq5Kj {
  background: rgba(59, 127, 212, 0.15);
  border-color: rgba(59, 127, 212, 0.5);
  color: #2c5b9c;
  font-weight: 600;
}

.TagFilter_count__12JT6 {
  font-size: 10px;
  color: #acacac;
  font-weight: 400;
}

.TagFilter_reset__0e\\+lj {
  background: none;
  border: none;
  font-size: 12px;
  color: var(--primary-color);
  cursor: pointer;
  text-decoration: underline;
}
.TagFilter_reset__0e\\+lj:disabled {
  color: #acacac;
  cursor: default;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/TagFilter/TagFilter.module.scss","webpack://./src/_common/scss/_variables.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SCGS;ADLX;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFF;;AAKA;EACE,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,cEZS;AFUX;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBEfM;EFgBN,yBAAA;EACA,mBAAA;EACA,cEvBS;EFwBT,eAAA;AAFF;AAIE;EACE,qBE5BO;AF0BX;;AAMA;EACE,oCAAA;EACA,qCAAA;EACA,cAAA;EACA,gBAAA;AAHF;;AAMA;EACE,eAAA;EACA,cEzCS;EF0CT,gBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,2BEzDQ;EF0DR,eAAA;EACA,0BAAA;AAHF;AAKE;EACE,cEtDO;EFuDP,eAAA;EACA,qBAAA;AAHJ","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.filter {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: $margin-m;\n}\n\n.group {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.groupLabel {\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $grey-300;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 10px;\n  font-size: 12px;\n  background: $white;\n  border: 1px solid $grey-200;\n  border-radius: 12px;\n  color: $grey-400;\n  cursor: pointer;\n\n  &:hover {\n    border-color: $grey-300;\n  }\n}\n\n.chipOn {\n  background: rgba(59, 127, 212, 0.15);\n  border-color: rgba(59, 127, 212, 0.5);\n  color: #2c5b9c;\n  font-weight: 600;\n}\n\n.count {\n  font-size: 10px;\n  color: $grey-300;\n  font-weight: 400;\n}\n\n.reset {\n  background: none;\n  border: none;\n  font-size: 12px;\n  color: $primary;\n  cursor: pointer;\n  text-decoration: underline;\n\n  &:disabled {\n    color: $grey-300;\n    cursor: default;\n    text-decoration: none;\n  }\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter": `TagFilter_filter__mcYRT`,
	"group": `TagFilter_group__rPgzn`,
	"groupLabel": `TagFilter_groupLabel__DGeFD`,
	"chip": `TagFilter_chip__4abxd`,
	"chipOn": `TagFilter_chipOn__dq5Kj`,
	"count": `TagFilter_count__12JT6`,
	"reset": `TagFilter_reset__0e+lj`
};
export default ___CSS_LOADER_EXPORT___;
